import DocumentViewer from './DocumentViewer';
export default DocumentViewer;
